import { Menu } from '@easyv/react-components';
import classNames from 'classnames';
import React, { ReactNode } from 'react';

export interface EntityCreateMenuData {
  key: string;
  label: string;
  icon?: ReactNode;
  desc?: ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  onMouseEnter?: () => void;
}

export interface EntityCreateMenuProps {
  onMouseLeave?: () => void;
  className?: string;
  data: EntityCreateMenuData[];
}

export function GizmoBaseContextMenu(props: EntityCreateMenuProps) {
  const { className, data, onMouseLeave } = props;
  return (
    <>
      {data.map((a) => (
        <Menu.Item
          key={a.key}
          disabled={a.disabled}
          className={classNames(
            '!bg-bgColor17171A hover:!bg-FFFFFF0A flex items-center !h-7 cursor-pointer px-3 !text-baseText justify-between',
            className,
          )}
          onClick={a.onClick}
          onMouseEnter={a.onMouseEnter}
        >
          <div className='flex items-center gap-x-2'>
            {a.icon}
            {a.label}
          </div>
          <div className='text-content3'>{a.desc}</div>
        </Menu.Item>
      ))}
    </>
  );
}
